import { useState } from 'react';
import Navbar from '../../pages/home/components/Navbar';
import FooterSection from '../../pages/home/components/FooterSection';
import EstimateModal from '../../pages/home/components/EstimateModal';

interface LayoutProps {
  children: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Navbar onEstimateClick={() => setModalOpen(true)} />
      <main>{children}</main>
      <FooterSection />
      <EstimateModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
